import Cookies from "js-cookie";

export const JSON_CONTENT_FORM_CONFIG = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-CSRFToken": Cookies.get("csrftoken"),
    Referer: "https://api.apogeemattress.com",
  },
};

export const MULTIPART_FORM_CONFIG = {
  headers: {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    "X-CSRFToken": Cookies.get("csrftoken"),
    Referer: "https://api.apogeemattress.com",
  },
};

// Function to get CSRF token dynamically
const getCSRFToken = () => Cookies.get("csrftoken");

// Function to return JSON content form config with dynamic CSRF token
export const getJSONContentFormConfig = () => {
  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": getCSRFToken(),
      //   Referer: "https://api.apogeemattress.com",
    },
  };
};

// Function to return multipart form config with dynamic CSRF token
export const getMultipartFormConfig = () => {
  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      "X-CSRFToken": getCSRFToken(),
      //   Referer: "https://api.apogeemattress.com",
    },
  };
};
